export default {
  ServiceErrorMessage__ERROR_DETAILS: "Error details",
  ServiceErrorMessage__ERROR_INCIDENT_IDENTIFIER: "Incident Identifier",
  ServiceErrorMessage__ERROR_LEGEND: "Error Code",
};
